'use strict';
angular.module('cvsApp').service('processDispositionService', ['networkService', 'processDispositionModel', 'configservice', 'PageValues', function (NS, PDM, config, PageValues) {

    function processDispositionService() {
        this.processDisposition = function (callBackSuccess, messageID) {
            var appConfig = config.appConfig();
            PageValues.appConfig = appConfig;

            var url = PageValues.appConfig.pbm_HEE_ServicesConfig.serviceURL + '/PBMAGPv1/descomm/processDisposition/1.0.0';
            if (url === "URL_ERROR") {

            } else {
                var request = {
                    url: url,
                    header: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json'
                    },
                    data: requestBody(messageID),
                    onSuccess: callBackSuccess
                }
                cvsUtility.commonServiceCode(url, "processDisposition", PDM, request, callBackSuccess, NS);
            }

        }

        var requestBody = function (messageID) {
            var apikey = PageValues.appConfig.pbm_HEE_ServicesConfig.apiKey;
            var date = new Date();			
            var currentYear = date.getFullYear();
            var currentMonth =convertToTwoDigit(date.getMonth() + 1);
            var currentDay = convertToTwoDigit(date.getDate());
            
            var hour = convertToTwoDigit(date.getHours());
            var minute = convertToTwoDigit(date.getMinutes());
            var second = convertToTwoDigit(date.getSeconds());

            var timeStamp =  currentMonth+ '/' + currentDay + '/' +  currentYear+ ' '+ hour 
                + ':' + minute + ':' + second;
            var xid = cvsUtility.queryMap.xid || PageValues.xid;
            var reqObj = {
                "processDispositionRequest": {
                "header": {
                    "serviceContext": {
                        "appName": "SPL_WEB",
                        "channelName": "WEB",
                        "lineOfBusiness": "SPECIALTY",
                        "deviceType": "DESKTOP",
                        "deviceToken": "12232434",
                        "deviceId": "device12345",
                        "responseFormat": "JSON",
                        "type": "PBMNJMS"
                    },
                    "securityContext": {
                        "securityType": "apiKey",
                        "apiKey": apikey
                    }
                },
                "details":{
                "requestMetaData": {
                    "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                    "lineOfBusiness": "Specialty",
                    "conversationID": messageID
                },
                "requestPayloadData": {
                    "data": [{
                        "opptyEvntId":PageValues.appConfig.validateResponse.secureData.opportunityId, 
                        "dispnCd": PageValues.appConfig.validateResponse.secureData.dispnCd, 
                        "dispnSubCd": PageValues.appConfig.validateResponse.secureData.dispnSubCd, 
                        "channelId": PageValues.appConfig.validateResponse.secureData.channelAltId ,
                        "dispnDt": timeStamp, // Current timestamp
                        "agntId":PageValues.appConfig.validateResponse.secureData.agntId, 
                        "dlvryMethodCd":PageValues.appConfig.validateResponse.secureData.dlvryMethodCd, 
                        "msgEvntId": PageValues.appConfig.validateResponse.secureData.messageEventId,

                    }]
                }
            }
                
            }
        };
            return reqObj;
            function convertToTwoDigit (number) {
                return (number < 10) ? '0' + number : number;
            }
        }
    }

    return new processDispositionService();
}]);